import * as _ from 'lodash-es';
import React, { useCallback, useRef } from 'react';
import { useAppDispatch } from '../app/redux/useAppSelector';
import { editorToasts, miscToasts } from '../toasts/toasts';
import { UIActions } from '../ui/uiSlice';
import useIsPublicView from '../utils/useIsPublicView';
import { useLinkAssetTokenToQuill } from './AssetTokenContext';
import { useNamespaceFormats } from './NamespaceFormatsProvider';
import type QuillComponentProps from './QuillComponentProps';
import ReactQuill from './ReactQuill';
import { FILE_OVERSIZED_ERROR, IMAGE_OVERSIZED_ERROR } from './Uploader';

const QuillComponent = ({
  namespace,
  initialContent,
  content,
  onMount,
  ...props
}: QuillComponentProps) => {
  const dispatch = useAppDispatch();
  const isPublicView = useIsPublicView();
  const initialContentRef = useRef(initialContent);
  const namespaceFormats = useNamespaceFormats();

  const handleUploadError = useCallback(
    (message: string) => {
      if (message === FILE_OVERSIZED_ERROR) {
        dispatch(UIActions.pushToast(editorToasts.attachmentSizeExceededError));
      } else if (message === IMAGE_OVERSIZED_ERROR) {
        dispatch(UIActions.pushToast(editorToasts.imageSizeExceededError));
      } else {
        dispatch(
          UIActions.pushToast(miscToasts.anyError({ message }), {
            duration: 3000,
          }),
        );
      }
    },
    [dispatch],
  );

  const linkAssetTokenToQuill = useLinkAssetTokenToQuill();

  return (
    <ReactQuill
      {...props}
      onMount={(quill) => {
        linkAssetTokenToQuill(quill);
        onMount?.(quill);
      }}
      moduleConfig={_.merge(
        { clipboard: { publicView: isPublicView } },
        props.moduleConfig,
      )}
      content={content ?? initialContentRef.current}
      onUploadError={handleUploadError}
      formats={namespaceFormats[namespace]}
    />
  );
};

export default QuillComponent;
